import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import AdminIndex from '~/javascript/components/negative_keywords/admin_index.vue'

export default class extends Controller {
  static targets = ['vueRoot']

  static values = {
    createUrl: String,
    updateUrlBase: String,
    csrfToken: String
  }

  connect() {
    this.vue = createApp(AdminIndex, {
      csrfToken: this.csrfTokenValue,
      createUrl: this.createUrlValue,
      updateUrlBase: this.updateUrlBaseValue
    })
    // Mount Vue on a sibling element so it doesn't wipe out the
    // server-rendered list table / header above.
    this.vue.mount(this.vueRootTarget)
  }

  disconnect() { this.vue?.unmount() }

  newList() {
    document.dispatchEvent(new CustomEvent('negative-keyword-list:new'))
  }

  editList(event) {
    const list = JSON.parse(event.currentTarget.dataset.list)
    document.dispatchEvent(new CustomEvent('negative-keyword-list:edit', { detail: list }))
  }
}
